var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9999 30.3164C41.3899 30.3164 40.8299 29.9664 40.5499 29.4264L39.8299 27.9764C39.3699 27.0664 38.1699 26.3164 37.1499 26.3164H34.8599C33.8299 26.3164 32.6299 27.0664 32.1699 27.9764L31.4499 29.4264C31.1699 29.9664 30.6099 30.3164 29.9999 30.3164C27.8299 30.3164 26.1099 32.1464 26.2499 34.3064L26.7699 42.5664C26.8899 44.6264 27.9999 46.3164 30.7599 46.3164H41.2399C43.9999 46.3164 45.0999 44.6264 45.2299 42.5664L45.7499 34.3064C45.8899 32.1464 44.1699 30.3164 41.9999 30.3164ZM34.4999 31.5664H37.4999C37.9099 31.5664 38.2499 31.9064 38.2499 32.3164C38.2499 32.7264 37.9099 33.0664 37.4999 33.0664H34.4999C34.0899 33.0664 33.7499 32.7264 33.7499 32.3164C33.7499 31.9064 34.0899 31.5664 34.4999 31.5664ZM35.9999 42.4364C34.1399 42.4364 32.6199 40.9264 32.6199 39.0564C32.6199 37.1864 34.1299 35.6764 35.9999 35.6764C37.8699 35.6764 39.3799 37.1864 39.3799 39.0564C39.3799 40.9264 37.8599 42.4364 35.9999 42.4364Z",
    fill: "#808985"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.816406,
    width: 71,
    height: 71,
    rx: 7.5,
    stroke: "#C4CFC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOrder);
export default __webpack_public_path__ + "static/media/cameraOrder.81bd5b31ef6ba6fb611718ce7945a269.svg";
export { ForwardRef as ReactComponent };